import React from "react";

export const SocialSelectionsTitlePage = () => {

    return (
        <div style={{height: "100%", position: "relative", fontDisplay: "swap"}}>
            <img
                src="https://res.cloudinary.com/indexpro/image/upload/v1668098166/Proposal/Social%20-%201.jpg"
                width="100%" height="100%"/>
            <div style={{
                position: "absolute",
                top: "250px",
                left: "60px",
                fontSize: "84px",
                fontWeight: "700",
                color: "white",
                lineHeight: 1
            }}>
                SOCIAL SELECTIONS
            </div>

            <div style={{
                position: "absolute",
                bottom: "80px",
                left: "60px",
                fontSize: "18px",
                color: "white",
                width: "300px"
            }}>
                “You must be the change you wish to see in the world.”
            </div>
            <div style={{position: "absolute", bottom: "40px", left: "60px", fontSize: "18px", color: "white"}}>
                Mahatma Gandhi
            </div>
        </div>
    )
}